import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Full-page gate shown when the API refuses an admin-only page with 403.
 *
 * @param {Object} props
 * @param {string} props.backTo Route the "Go Back" link points at.
 */
const AdminGate = ({ backTo }) => (
  <div className="min-h-screen bg-clay-bg flex items-center justify-center">
    <div className="card-clay text-center p-8">
      <div className="text-6xl mb-4">🔒</div>
      <h2 className="font-display text-2xl font-bold text-heading mb-2">Admin Access Required</h2>
      <p className="text-secondary-text mb-6">You don&apos;t have permission to view this page.</p>
      <Link to={backTo} className="btn-clay inline-flex items-center">Go Back</Link>
    </div>
  </div>
);

export default AdminGate;
